"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valbrona": {
    "1c14629b": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "skipSearch": false
    }],
    "candalino": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9f0e6f6": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "skipSearch": false
    }],
    "maisano": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ee2648c": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "skipSearch": false
    }],
    "osigo": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a585d947": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "skipSearch": false
    }],
    "visino": [{
      "hkey": "5887eb63",
      "slug": "valbrona",
      "name": "Valbrona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;